import { formatDistance } from 'date-fns'
import { faIR, enUS } from 'date-fns/locale'
export const toDateTime = (
  date: Date,
  language?: string,
  showSeconds?: boolean,
) => {
  return date
    .toLocaleString(language ?? 'fa-IR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: showSeconds ? '2-digit' : undefined,
    })
    .replace(',', ' ')
}

export const toDate = (date: Date, language?: string) => {
  return date.toLocaleString(language ?? 'fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}

export const toTime = (date: Date, language?: string) => {
  return date.toLocaleString(language ?? 'fa-IR', {
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function convertDateTimeToMonth(
  time: string | number,
  language?: string,
) {
  const month = new Intl.DateTimeFormat(language ?? 'fa-IR', {
    month: 'long',
  }).format(new Date(time))
  return month
}
export function convertDateTimeToDay(time: string | number, language?: string) {
  return formatDistance(new Date(time), new Date(), {
    addSuffix: true,
    locale: language === 'fa' ? faIR : enUS,
  })
}
